<template>
  <div class="introduction">
    <p
      v-for="(item, index) in infos"
      class="row"
      :key="index"
      @click="handleGo"
    >
      <span class="img-box">
        <img :src="item.url" alt="" />
      </span>
      <span class="name">{{item.name}}</span>
    </p>
  </div>
</template>

<script>
export default {
  name: 'index',
  data () {
    const {
      home: {
        future1,
        future2,
        future3,
        future4
      }
    } = this.$images
    return {
      infos: [
        { url: future1, name: 'オンライン販売' },
        { url: future2, name: '住宅関連' },
        { url: future3, name: '物流センター' },
        { url: future4, name: '工場設立' }
      ]
    }
  },
  methods: {
    handleGo () {
      window.location.href = '/#/future'
    }
  }
}
</script>

<style lang="less" scoped>
.introduction{
  width: 1531px;
  margin-top: 51px;
  margin-left: 192px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;

  .row{
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 693px;
    height: 197px;
    background: #374475;
    border-radius: 10px;
    margin-bottom: 45px;
    overflow: hidden;
    position: relative;
    cursor: pointer;

    &:after {
      content: '';
      display: block;
      position: absolute;
      top: -300px;
      left: -200%;
      background: white;
      width: 100px;
      height: 1000px;
      opacity: .2;
      transform: rotate(-45deg);
    }

    &:hover:after {
      left: 200%;
      transition: all 2s cubic-bezier(0.3, 1, 0.2, 1);
    }

    .img-box{
      margin-left: 55px;
    }

    .name{
      font-family: 04KanjyukuGothic;
      font-weight: 400;
      font-size: 28px;
      color: #FFFFFF;
      line-height: 68px;
      margin-left: 35px;
    }
  }
}
</style>
